import React from 'react';
import Chart from 'react-apexcharts';
import { Card, CardContent } from '@material-ui/core';
import moment from 'moment';

function CpuUsage({ classes, data, samples }) {
  const buildDataset = data => {
    return {
      options: {
        chart: {
          animations: {
            enabled: true,
            easing: 'easein',
            speed: 120,
            animateGradually: {
              enabled: true,
              delay: 250
            },
            dynamicAnimation: {
              enabled: true,
              speed: 80
            }
          },
          stacked: false,
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          offsetX: -10
        },
        title: {
          text: 'CPU Usage'
        },
        xaxis: {
          type: 'datetime',
          range: 120000,
          labels: {
            rotate: -30,
            rotateAlways: true,
            formatter: function(val, timestamp) {
              // hh:mm:ss a
              return moment(new Date(timestamp)).format('hh:mm:ss');
            }
          }
        },
        yaxis: {
          decimalsInFloat: 2,
          min: 0,
          max: 1.0
        }
      },
      series: samples.series
    };
  };

  const dataset = buildDataset(data);
  return (
    <Card>
      <CardContent className={classes.lineChartContainer}>
        <Chart
          options={dataset.options}
          series={dataset.series}
          type="area"
          width="100%"
          height="320"
        />
      </CardContent>
    </Card>
  );
}

export default CpuUsage;
